import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import messages from '../../user-messages/home.json'

export const CurrentDateTime = ({ currentDate }) => {
    return (
        <Stack spacing={1}>
            <Typography><span>{messages.date}:</span> {currentDate.toLocaleDateString('en-GB')}</Typography>
            <Typography><span>{messages.time}:</span> {currentDate.toLocaleTimeString()}</Typography>
        </Stack>
    );
};